<template>
  <van-notice-bar left-icon="volume-o" :text="downTime" />
</template>

<script setup>
import { defineProps, onMounted, ref, onUnmounted } from 'vue';
import { formatDateToPeriods } from '@/utils';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const downTime = ref('');
const props = defineProps({
  endTime: {
    type: String,
    default: '',
  },
});
var timer = null;
// 补零到两位("5" → "05","12" → "12")
const pad2 = (v) => String(v).padStart(2, '0');
const countTime = () => {
  //获取当前时间
  const date = new Date();
  const now = date.getTime();
  // 拼一个 iOS Safari 也能解析的 ISO 格式截止时间
  // (Safari 不认 "2025-7-5 14:30:00" 这种,认 "2025-07-05T14:30:00")
  const yyyy = date.getFullYear();
  const mm = pad2(date.getMonth() + 1);
  const dd = pad2(date.getDate());
  const rawEnd = (props.endTime || '00:00:00').trim();
  // 兼容后端只给 "HH:MM" 的情况,补上 ":00"
  const paddedTime = rawEnd.split(':').length === 2 ? `${rawEnd}:00` : rawEnd;
  const endDate = new Date(`${yyyy}-${mm}-${dd}T${paddedTime}`);
  const end = endDate.getTime();
  //时间差
  const differTime = end - now;
  //定义变量,h,m,s保存倒计时的时间(先给兜底值,防止 else 分支拿到 undefined)
  let h = '00',
    m = '00',
    s = '00';
  if (!isNaN(differTime) && differTime >= 0) {
    h = pad2(Math.floor(differTime / 1000 / 60 / 60));
    m = pad2(Math.floor((differTime / 1000 / 60) % 60));
    s = pad2(Math.floor((differTime / 1000) % 60));
    downTime.value = `${t('home.sorteo')}:  ${formatDateToPeriods(new Date())}   ${h}H/${m}M/${s}S`;
    //递归调用函数所以是延时器不是定时器
    timer = setTimeout(function () {
      countTime();
    }, 3000);
  } else {
    downTime.value = `${t('home.sorteo')}:${formatDateToPeriods(new Date())}   ${h}H/${m}M/${s}S`;
    clearTimeout(timer);
  }
};
onMounted(() => {
  countTime();
});
onUnmounted(() => {
  clearTimeout(timer);
});
</script>

<style lang="scss" scoped></style>
